import dayjs from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useTableContext } from '../../contexts/TableContext';

//Servicios
import { LogService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import UserLogs from './UserLogs';

function UserLogsContainer({}) {
    const { token, masters } = useGlobalContext();
    const { state } = useTableContext();
    const tablePage = useMemo(() => state.UserLogsPage, [state.UserLogsPage]);

    const [loader, setLoader] = useState(false);
    const [tablePages, setTablePages] = useState();

    const params = useParams();

    useEffect(() => {
        const getUserLogsCuantity = async () => {
            try {
                setLoader(true);

                const userLogsCuantity = await LogService.totalRecords({
                    token,
                    objeto: 1,
                    objeto_id: parseInt(params.id),
                });

                if (userLogsCuantity) setTablePages(userLogsCuantity.data);

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        const getUserLogs = async () => {
            try {
                setLoader(true);

                const userLogs = await LogService.byObject({
                    token,
                    objeto: 1,
                    objeto_id: parseInt(params.id),
                    pagina: tablePage,
                    cantidad: tableData.pagination,
                });

                if (userLogs) {
                    setTableData(buildTableData(userLogs.data));
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getUserLogsCuantity();
        getUserLogs();
    }, [tablePages, tablePage]);

    const buildTableData = (data = []) => {
        return {
            headers: ['Fecha', 'Hora', 'Responsable', 'Nivel', 'Acción'],
            tablePages,
            pagination: 10,
            pageType: 'UserLogsPage',
            data:
                data.length > 0
                    ? data?.map((log) => {
                          return {
                              fecha: dayjs(log.fecha).format('DD-MM-YYYY'),
                              hora: dayjs(log.fecha).format('HH:mm:ss'),
                              responsable: `${log.apellido}, ${log.nombre}`,
                              nivel: masters.UserTypes?.find(
                                  (m) => m.id === log.tipo
                              )?.nombre,
                              accion: masters.AccionTypes?.find(
                                  (at) => at.id === log.accion
                              ).nombre.replace(/_/g, ' '),
                          };
                      })
                    : [],
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? <Spinner /> : <UserLogs tableData={tableData} />;
}

export default UserLogsContainer;
